import { render, staticRenderFns } from "./ArmarioItem.vue?vue&type=template&id=04f69246&scoped=true"
import script from "./ArmarioItem.vue?vue&type=script&lang=js"
export * from "./ArmarioItem.vue?vue&type=script&lang=js"
import style0 from "./ArmarioItem.vue?vue&type=style&index=0&id=04f69246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f69246",
  null
  
)

export default component.exports